(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["accordion-template"]) return;
  try {
    
  jQuery('#faqs-accordion .accordion-block__content-desc').hide();
  jQuery('#faqs-accordion .accordion-block__content-title h4').on('click', function(e) {
	  e.preventDefault();
	  jQuery(this).closest('.accordion').parent().siblings().find('.accordion-block__content').removeClass('active');
	  jQuery(this).closest('.accordion').parent().siblings().find('.accordion-block__content-desc').hide();
      jQuery(this).parent().next().show();
      jQuery(this).parent().parent().toggleClass('active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-mates-template"]) return;
  try {
    
  jQuery('#mates-faqs-accordion .accordion-block__content-desc').hide();
  jQuery('#mates-faqs-accordion .accordion-block__content-title h4').on('click', function(e) {
	  e.preventDefault();
	  jQuery(this).closest('.accordion').parent().siblings().find('.accordion-block__content').removeClass('active');
	  jQuery(this).closest('.accordion').parent().siblings().find('.accordion-block__content-desc').hide();
      jQuery(this).parent().next().show();
      jQuery(this).parent().parent().toggleClass('active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-dropdown-section"]) return;
  try {
    
 
  jQuery("#goToProductSelector").on('click', function(e) {
  	e.preventDefault();
  	var headerHeight = jQuery("#shopify-section-header").innerHeight(),
		selectorTop = jQuery(".product-images-container").innerHeight(),
  		goTo = selectorTop + headerHeight - 60;
  	jQuery(window).scrollTop(goTo);
  });
  
  var headerHeight = jQuery("#shopify-section-header"), 
  	stickyElement = jQuery(".product-sticky-wrapper1"),
  	stickyClass = "show sticky-menu sticky-menu-show",
  	stickyPos = jQuery("#show-menu-line").offset().top,
  	stickyHeight, paddingTop;
  
  jQuery(window).scroll(function() {
      var winTop = jQuery(this).scrollTop();

      if(winTop >= stickyPos) {
  		jQuery(".mobile-sticky").addClass("show");
        jQuery(".mobile-nav-bar-wrapper").addClass("show1");
  	  } else {
  		jQuery(".mobile-sticky").removeClass("show");
        jQuery(".mobile-nav-bar-wrapper").removeClass("show1");
  	  }
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faqs"]) return;
  try {
      
  jQuery('#product-faqs-accordion .accordion-block__content-desc').hide();
  jQuery('#product-faqs-accordion .accordion-block__content-title h4').on('click', function(e) {
      jQuery('#product-faqs-accordion .accordion-block__content-desc').show();
      jQuery(this).parent().parent().toggleClass('active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
 
  jQuery("#goToProductSelector").on('click', function(e) {
  	e.preventDefault();
  	var headerHeight = jQuery("#shopify-section-header").innerHeight(),
		selectorTop = jQuery(".product-images-container").innerHeight(),
  		goTo = selectorTop + headerHeight - 60;
  	jQuery(window).scrollTop(goTo);
  });
  
  var headerHeight = jQuery("#shopify-section-header"), 
  	stickyElement = jQuery(".product-sticky-wrapper1"),
  	stickyClass = "show sticky-menu sticky-menu-show",
  	stickyPos = jQuery("#show-menu-line").offset().top,
  	stickyHeight, paddingTop;
  
  jQuery(window).scroll(function() {
      var winTop = jQuery(this).scrollTop();

      if(winTop >= stickyPos) {
  		jQuery(".mobile-sticky").addClass("show");
        jQuery(".mobile-nav-bar-wrapper").addClass("show1");
  	  } else {
  		jQuery(".mobile-sticky").removeClass("show");
        jQuery(".mobile-nav-bar-wrapper").removeClass("show1");
  	  }
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sweat-work-play-women"]) return;
  try {
    
 /*jQuery("#playvideo").click(function(){
  jQuery(this).hide();
  jQuery('#playvideo-image').hide();
    //as noted in addendum, check for querystring exitence
    var symbol = jQuery("#bannervideo")[0].src.indexOf("?") > -1 ? "&" : "?";
    //modify source to autoplay and start video
    jQuery("#bannervideo")[0].src += symbol + "autoplay=1";
 });*/
      

jQuery(document).ready(function(e) {
    //as noted in addendum, check for querystring exitence
    var symbol = jQuery("#bannervideo")[0].src.indexOf("?") > -1 ? "&" : "?";
    //modify source to autoplay and start video
    jQuery("#bannervideo")[0].src += symbol + "autoplay=1";
 });

  jQuery('#swp-accordion .accordion-block__content-desc').hide();
  jQuery('#swp-accordion .accordion-block__content-title h4').on('click', function(e) {
    e.preventDefault();
    jQuery(this).closest('.accordion').parent().siblings().find('.accordion-block__content').removeClass('active');
    jQuery(this).closest('.accordion').parent().siblings().find('.accordion-block__content-desc').hide();
      jQuery(this).parent().next().show();
      jQuery(this).parent().parent().toggleClass('active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sweat-work-play"]) return;
  try {
    
 /*jQuery("#playvideo").click(function(){
  jQuery(this).hide();
  jQuery('#playvideo-image').hide();
    //as noted in addendum, check for querystring exitence
    var symbol = jQuery("#bannervideo")[0].src.indexOf("?") > -1 ? "&" : "?";
    //modify source to autoplay and start video
    jQuery("#bannervideo")[0].src += symbol + "autoplay=1";
 });*/

jQuery(document).ready(function(e) {
    //as noted in addendum, check for querystring exitence
    var symbol = jQuery("#bannervideo")[0].src.indexOf("?") > -1 ? "&" : "?";
    //modify source to autoplay and start video
    jQuery("#bannervideo")[0].src += symbol + "autoplay=1";
 });

  jQuery('#swp-accordion .accordion-block__content-desc').hide();
  jQuery('#swp-accordion .accordion-block__content-title h4').on('click', function(e) {
    e.preventDefault();
    jQuery(this).closest('.accordion').parent().siblings().find('.accordion-block__content').removeClass('active');
    jQuery(this).closest('.accordion').parent().siblings().find('.accordion-block__content-desc').hide();
      jQuery(this).parent().next().show();
      jQuery(this).parent().parent().toggleClass('active');
  });

  } catch(e) { console.error(e); }
})();

})();
